import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import "@/App.css";
import { Toaster } from "sonner";
import Layout from "@/components/Layout";
import Login from "@/pages/Login";
import Dashboard from "@/pages/Dashboard";
import Orders from "@/pages/Orders";
import OrderDetail from "@/pages/OrderDetail";
import KanbanBoard from "@/pages/KanbanBoard";
import SerigrafiaQueue from "@/pages/SerigrafiaQueue";
import Inventory from "@/pages/Inventory";
import InventoryPrint from "@/pages/InventoryPrint";
import Collaborators from "@/pages/Collaborators";
import BlingSettings from "@/pages/BlingSettings";
import Products from "@/pages/Products";
import Customers from "@/pages/Customers";
import CustomerDetail from "@/pages/CustomerDetail";
import CupColors from "@/pages/CupColors";
import SilkColors from "@/pages/SilkColors";
import FactoryPanel from "@/pages/FactoryPanel";
import ArchivedPanel from "@/pages/ArchivedPanel";
import Reports from "@/pages/Reports";
import ProductionCenter from "@/pages/ProductionCenter";
import SalesDashboard from "@/pages/SalesDashboard";
import AccountsPayable from "@/pages/AccountsPayable";
import Payroll from "@/pages/Payroll";
import BatchPrint from "@/pages/BatchPrint";
import StockMovement from "@/pages/StockMovement";
import ConfigStationLogins from "@/pages/ConfigStationLogins";
import AuditLog from "@/pages/AuditLog";
import HomeGate from "@/pages/HomeGate";
import Backup from "@/pages/Backup";
import FiscalLayout from "@/pages/fiscal/FiscalLayout";
import FiscalEmit from "@/pages/fiscal/FiscalEmit";
import FiscalHistory from "@/pages/fiscal/FiscalHistory";
import FiscalReport from "@/pages/fiscal/FiscalReport";
import FiscalConfig from "@/pages/fiscal/FiscalConfig";
import PermGate from "@/components/PermGate";
import InstallAppBanner from "@/components/InstallAppBanner";
import SystemStatusOverlay from "@/components/SystemStatusOverlay";
import CollabPinProvider from "@/context/CollabPinContext";
import { registerSW } from "@/lib/pwa";

// Registra o Service Worker uma única vez ao carregar o bundle.
registerSW();

// Helper para reduzir ruído no JSX
const gated = (perm, El) => <PermGate perm={perm}>{El}</PermGate>;

function App() {
  return (
    <div className="App">
      <Toaster position="top-right" richColors closeButton />
      <InstallAppBanner />
      <SystemStatusOverlay />
      <CollabPinProvider>
        <BrowserRouter>
          <Routes>
            <Route path="/login" element={<Login />} />
            <Route path="/queue" element={<SerigrafiaQueue />} />
            <Route path="/queue/:token" element={<SerigrafiaQueue />} />
            <Route path="/orders/print-batch" element={<BatchPrint />} />
            <Route element={<Layout />}>
              <Route path="/" element={<HomeGate />} />
              <Route path="/orders" element={gated("orders", <Orders />)} />
              <Route path="/orders/:id" element={gated("orders", <OrderDetail />)} />
              <Route path="/kanban" element={gated("kanban", <KanbanBoard />)} />
              <Route path="/arquivados" element={gated("kanban", <ArchivedPanel />)} />
              <Route path="/painel" element={gated("factory_panel", <FactoryPanel />)} />
              <Route path="/estoque/movimentacao" element={gated("stock_movement", <StockMovement />)} />
              <Route path="/relatorios" element={gated("reports", <Reports />)} />
              <Route path="/relatorios/central-producao" element={gated("production_reports", <ProductionCenter />)} />
              <Route path="/relatorios/vendas" element={gated("sales_bi", <SalesDashboard />)} />
              <Route path="/products" element={gated("products", <Products />)} />
              <Route path="/customers" element={gated("customers", <Customers />)} />
              <Route path="/customers/:id" element={gated("customers", <CustomerDetail />)} />
              <Route path="/cadastros/cup-colors" element={gated("cup_colors", <CupColors />)} />
              <Route path="/cadastros/silk-colors" element={gated("silk_colors", <SilkColors />)} />
              <Route path="/inventory" element={gated("inventory", <Inventory />)} />
              <Route path="/inventory/print" element={gated("inventory", <InventoryPrint />)} />
              <Route path="/collaborators" element={<Collaborators />} />
              <Route path="/financeiro/contas-a-pagar" element={gated("finance", <AccountsPayable />)} />
              <Route path="/financeiro/folha" element={gated("payroll", <Payroll />)} />
              <Route path="/settings/bling" element={<BlingSettings />} />
              <Route path="/configuracoes/logins" element={<ConfigStationLogins />} />
              <Route path="/auditoria/apontamentos" element={gated("audit", <AuditLog />)} />
              <Route path="/backup" element={gated("backup", <Backup />)} />
              <Route path="/fiscal" element={gated("fiscal", <FiscalLayout />)}>
                <Route index element={<Navigate to="emit" replace />} />
                <Route path="emit" element={<FiscalEmit />} />
                <Route path="history" element={<FiscalHistory />} />
                <Route path="report" element={<FiscalReport />} />
                <Route path="config" element={<FiscalConfig />} />
              </Route>
            </Route>
            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
        </BrowserRouter>
      </CollabPinProvider>
    </div>
  );
}

export default App;
